import { BaseApi, type ItemResponse, type PaginatedResponse, type RequestParams } from '@bv/api';

import { WhatsAppTemplateType } from '../types/template';

class TemplatesApi extends BaseApi {
  public constructor() {
    super('conversations/all-whats-app-template');
  }

  public async get(params?: RequestParams): Promise<{ data: PaginatedResponse<WhatsAppTemplateType> }> {
    return this.request({
      method: 'get',
      params,
    });
  }
}
class TemplateApi extends BaseApi {
  public constructor() {
    super('conversations/whats-app-template');
  }

  public async show(id: string): Promise<ItemResponse<WhatsAppTemplateType>> {
    return this.request<WhatsAppTemplateType, ItemResponse<WhatsAppTemplateType>>({
      method: 'get',
      url: id,
    });
  }
}

export const templatesApi = new TemplatesApi();
export const templateApi = new TemplateApi();
